import axios from 'axios';

const TOKEN_KEY = 'jwtToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const USER_ID_KEY = 'userId';
export function storeToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}


export function deleteToken() {
    localStorage.removeItem(TOKEN_KEY);
}

export function tokenExists() {
    return !!getToken();
}

export function storeRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function deleteRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function storeUserId(userId) {
    localStorage.setItem(USER_ID_KEY, userId);
}

export function getUserId() {
    return localStorage.getItem(USER_ID_KEY);
}

export function deleteUserID() {
    localStorage.removeItem(USER_ID_KEY);
}

export async function refreshToken() {
    const refreshToken = getRefreshToken();

    if (!refreshToken) {
        return null;
    }

    try {
        let BASE_URL;
        const response = await axios.post(`${BASE_URL}/refresh?refreshToken=` . refreshToken);
        const { token } = response.data.token;

        storeToken(token);

        return token;
    } catch (error) {
        console.error(error);
        return null;
    }
}
